import React from "react";
import Card from "react-bootstrap/Card";
import { FaPersonBiking } from "react-icons/fa6";
import { BiSolidCameraMovie } from "react-icons/bi";
import { FaChalkboardTeacher } from "react-icons/fa";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify", lineHeight: '2.5rem' }}>
            {/* Hi. I am <span className="purple">Natnael Fisseha </span>
            from <span className="purple"> Addis Ababa.</span>
            <br />
            I am a third year software engineering student at AASTU.
            <br />
            <br />
            Apart from coding, some other activities that I love to do! */}
            I grew up in Addis Ababa. I discovered my <span className="flex-item"> passion</span> for coding and software engineering when I entered high school. After that, I started tinkering with a few programming languages such as
            <span className="flex-item"> C++</span>, <span className="flex-item"> Java</span>, <span className="flex-item"> Arduino</span>,  and <span className="flex-item"> Python</span>. When I joined the university, I narrowed down my focus to <span className="flex-item"> web dev</span>.
            Now, I am an accomplished <span className="flex-item"> full-stack </span> web developer, ready for action.
          </p>
          <div>
            <p >Aside from coding, I enjoy: </p>
            <ul>
              <li className="about-activity">
                <FaPersonBiking style={{ marginRight: "8px", marginBottom: "2.3px" }} /> Content creation and Graphics design
              </li>
              <li className="about-activity">
                <BiSolidCameraMovie style={{ marginRight: "8px", marginBottom: "2.3px" }} /> Biking 
              </li>
              <li className="about-activity">
                <FaChalkboardTeacher style={{ marginRight: "8px", marginBottom: "2.3px" }} /> Mentoring 
              </li>
            </ul>
          </div>


          <p style={{ color: "rgb(155 126 172)" }}>
            "True nobility is being superior to your former self!"{" "}
          </p>
          <footer className="blockquote-footer">Ernest Hemingway</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
